import React from 'react';
import Spinner from '../common/Spinner/Spinner';

import './LoadingSection.scss';

interface LoadingSectionProps {
    height?: number | string;
    spinnerSize?: number | string;
    children?: (spinner: React.ReactNode) => React.ReactChildren | React.ReactChild;
}

export default ({ height, spinnerSize = '10vh', children }: LoadingSectionProps) => {
    let heightStyle = {};
    if (height) {
        const sizeString: string = typeof height === 'number' ? `${height}px` : height;
        heightStyle = { height: sizeString };
    }
    const spinner = <Spinner size={spinnerSize} />;
    return (
        <section className='loadingSection' style={heightStyle}>
            {children ? children(spinner) : spinner}
        </section>
    );
};